"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var NotificationItem_1 = __importDefault(require("../NotificationItem"));
var ItemSold_1 = __importDefault(require("../../Icons/Notifications/ItemSold"));
var NotificationItemNFTLink_1 = __importDefault(require("../NotificationItemNFTLink"));
var i18N = {
    en: { description: 'Someone just bought your ', title: 'Item Sold' },
    es: { description: 'Alguien acaba de comprar tu ', title: 'Item vendido' },
    zh: { description: '有人刚买了你的 ', title: '已售商品' }
};
var ItemSoldNotification = function (_a) {
    var notification = _a.notification, locale = _a.locale;
    return (react_1.default.createElement(NotificationItem_1.default, { image: {
            url: notification.metadata.image,
            rarity: notification.metadata.rarity,
            icon: react_1.default.createElement(ItemSold_1.default, null)
        }, timestamp: notification.timestamp, isNew: !notification.read, locale: locale },
        react_1.default.createElement("p", { className: "dcl notification-item__content-title" }, i18N[locale].title),
        react_1.default.createElement("p", { className: "dcl notification-item__content-description" },
            i18N[locale].description,
            ' ',
            react_1.default.createElement(NotificationItemNFTLink_1.default, { rarity: notification.metadata.rarity, name: notification.metadata.nftName, link: notification.metadata.link }))));
};
exports.default = ItemSoldNotification;
